import './radioButton.scss';
import {useTranslation} from "react-i18next";
import type {RadioButton_Props} from "./RadioButton.interface";
import { Paragraph } from "../../Elements";

/**
 * Primary UI component for user interaction
 */
export function StandardRadioButton  (props:RadioButton_Props) {
    
    const {t} = useTranslation();
    
    return ( <div className={["radiobutton-wrapper", props.className, props.hide ? "hide" : "", props.recommended ? "highlight" : "no-highlight"].join(" ")}
                onClick={props.disabled || !props.recommended ? undefined : props.onClick}>
            {props.recommended && <>

              <div className={"recommended-container"} onClick={props.disabled || props.recommended ? undefined : props.onClick}>
                  <div className={"recommended"}>{t("button.recommended")}</div>
                  {props.recommendedLabel && <Paragraph text={props.recommendedLabel} />}
              </div>
            </>}
            <div className="radiobutton-input-row" onClick={props.disabled || props.recommended ? undefined : props.onClick}>
                <div className="input">
                    <input id={props.id} aria-label={props.id} type="radio" readOnly
                           checked={props.selected}/>
                </div>
                <div>
                    <label htmlFor={props.id} aria-label={props.id}>
                        {props.label}
                    </label>
                </div>
            </div>
        </div>);
}